export const OPEN_MAIN_MENU = "@layout/OPEN_MAIN_MENU";
export const CLOSE_MAIN_MENU = "@layout/CLOSE_MAIN_MENU";

export const OPEN_PANE = "@layout/OPEN_PANE";
export const CLOSE_PANE = "@layout/CLOSE_PANE";
